module.exports = __webpack_public_path__ + "static/media/streaming-services.3315f1b3.png";